import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const MoreIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 8)}
      viewBox="0 0 27.686 7.61"
      {...svgProps}
    >
      <g
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <circle cx="3.805" cy="3.805" r="3.055" />
        <circle cx="23.881" cy="3.805" r="3.055" />
        <circle cx="13.843" cy="3.805" r="3.055" />
      </g>
    </SVG>
  );
};
